import { ByWeekAverageDailyDeskUsage, LiveAverageDailyDeskUsage } from '@shared/models/average-daily-desk-usage.model';
import {
  AverageCapacityUtilizationInOrganizationUnits,
  ByWeekCapacityUtilizationDepartmentsComparison,
  CapacityUtilizationByOrganizationUnit,
  HybridIndex,
  LiveHourlyUtilizationOfWorkspace,
  WorkspaceUtilizationSummary
} from '@shared/models/charts.model';
import { DateRangeModel } from '@shared/models/date-range.model';
import { HybridProfileDistribution } from '@shared/models/hybrid-profile-distribution.model';
import { SpaceTypeUtilization, TimeSlotsUtilization } from '@shared/models/utilization.model';

export enum ReportType {
  FINAL = 'FINAL',
  QUARTERLY = 'QUARTERLY',
  MONTHLY = 'MONTHLY',
  OTHER = 'OTHER'
}

export enum ReportFileStatus {
  PUBLISHED = 'PUBLISHED',
  READY = 'READY',
  GENERATED = 'GENERATED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export interface ResearchReport {
  companyLogo?: string;
  businessUnitName: string;
  utilizationSummary: WorkspaceUtilizationSummary;
  hybridIndex: HybridIndex;
  workingModel: string;
  averageLiveDailyDeskUsage: LiveAverageDailyDeskUsage;
  averageDailyDeskUsageByWeek: ByWeekAverageDailyDeskUsage;
  timeSlotsUtilization: TimeSlotsUtilization;
  spaceTypeUtilization: SpaceTypeUtilization;
  searchRange: DateRangeModel;
  maxUtilisationRate: number;
  maxUtilisationTime: number;
  avgUtilisationRate: number;
  avgUtilisationTime: number;
  headCount: number;
  deskDensity: number;
  hourlyUtilizationOfWorkspace: LiveHourlyUtilizationOfWorkspace;
  hybridProfileDistribution: HybridProfileDistribution;
  maxUtilizedDepartment: DepartmentUtilisation;
  minUtilizedDepartment: DepartmentUtilisation;
  workspaceUtilizationInOrganizationUnitsByWeek: ByWeekCapacityUtilizationDepartmentsComparison;
  capacityUtilizationByOrganizationUnit: CapacityUtilizationByOrganizationUnit[];
  averageCapacityUtilizationInOrganizationUnits: AverageCapacityUtilizationInOrganizationUnits;
}

interface DepartmentUtilisation {
  unitName: string;
  minUtilization: number;
  maxUtilization: number;
}
